import { render } from "./chat_message.vue?vue&type=template&id=521cd9a4"
import script from "./chat_message.js?vue&type=script&lang=js&external"
export * from "./chat_message.js?vue&type=script&lang=js&external"

import "./chat_message.vue?vue&type=style&index=0&id=521cd9a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__